<div>
  <div class="absolute top-1 left-1 z-30">{{barcodeValue}}</div>
  <barcode-scanner-livestream
    type="code_128"
    deviceId="{{deviceId}}"
    (valueChanges)="onValueChanges($event)"
  ></barcode-scanner-livestream>
</div>
